import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid,
  IconButton,
  Paper,
  TablePagination,
  Tooltip,
} from "@mui/material";
import ReportHeader from "./ReportHeader";
import SummaryReport from "./SummaryReport";
import moment from "moment";
import { SummaryAction } from "../../actions/summary";
import IndividualReport from "./IndividualReport";
import LoadingComponent from "../CommonComponents/LoadingComponent";
import TopViewNav from "../CommonComponents/TopViewNav";
import { useSelector } from "react-redux";
import redirectSlice from "../Dashboard/redirectSlice";
import ExportReport from "../CommonComponents/ExPortExcel";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { ScheduledAction } from "../../actions/ScheduledMeting";
import ShoeListHeader from "../Clients/ShoeListHeader";
import AttributionIcon from "@mui/icons-material/Attribution";
import { Padding } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { dynamiceForm } from "../../actions/DynamiceForm";
import CombineEmpWiseReport from "./CombineEmpWiseReportExcel";
import SummaryReportExportExcel from "./SummaryReportExportExcel";
import { useRef } from "react";
import { expenseExportBlob } from "../Expense/expenseExportBlob";
import {
  exportEmployeewiseReportExcel,
  exportSummaryReportExcel,
} from "./excelExportHelper";
import { useLocalStorage } from "../../Hooks/Index";

const emptyArray = [];

const feSideHeaders = [
  {
    id: "temp1",
    name: "Odometer Details",
    displayName: "Odometer Details",
    isShowOnWeb: true,
    isShowOnApp: true,
    isActive: true,
    headerMasterId: 2,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    userId: null,
    isNotForWeb: false,
    isNotForApp: false,
    subTemplateTypeId: null,
  },

  {
    id: "temp2",
    name: "Odometer Distance",
    displayName: "Odometer Distance (Kms)",
    isShowOnWeb: true,
    isShowOnApp: true,
    isActive: true,
    headerMasterId: 2,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    userId: null,
    isNotForWeb: false,
    isNotForApp: false,
    subTemplateTypeId: null,
  },
];

const Report = () => {
  const navigate = useNavigate();
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  // const { id } = useParams();
  const id = sessionStorage.getItem("navigatedOutdoordutiesFilter");

  const [selectedSite] = useLocalStorage("selectedSite", null);

  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(
    moment(moment().startOf("day")).format("YYYY-MM-DD"),
  );
  const [toDate, setToDate] = useState(
    moment(moment().endOf("day")).format("YYYY-MM-DD"),
  );
  const [fromDate1, setFromDate1] = useState();
  const [userList, setUserList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [userListId, setuserListId] = useState([]);
  const [userId, setUserId] = useState([]);
  const [teamfiletdataemp, setTeamfiletdataemp] = useState([]);
  const [TeamListData, setTeamListData] = useState([]);
  const [singleEmployee, setSingleEmployee] = useState([]);
  const [TeamfilterId, setTeamFilterId] = useState({});
  const [showHeaderbyCompany, setShowHeaderbyCompany] = useState([]);
  const [TotalEmp, setTotalEmp] = useState();
  const [TotalApproved, setTotalApproved] = useState();
  const [TotalPendding, setTotalPendding] = useState();
  const [TotalReject, setTotalReject] = useState();
  const [StatusId, setStatusId] = useState({});
  const [configurationName, setConfigurationName] = useState();
  const [showAttendanceViewModal, setShowAttendanceViewModal] = useState(false);

  const [NewClientTitle, setNewClientTitle] = React.useState("");
  const [UniqueClients, setUniqueClients] = useState("");
  const [selectOptonCustomer, setSelectOptonCustomer] = React.useState("");
  const [selectOptonSatatus, setSelectOptonSatatus] = React.useState("");

  const [communicationDetails, setCommunicationDetails] = useState([]);
  const [communicationDetailsHeader, setCommunicationDetailsHeader] = useState(
    [],
  );
  const [
    communicationDetailsDynamiceHeader,
    setCommunicationDetailsDynamiceHeader,
  ] = useState([]);

  const [filterCommunicationDetails, setFilterCommunicationDetails] = useState(
    [],
  );
  const fromDateToShowRef = useRef(
    moment(moment().startOf("day")).format("YYYY-MM-DD"),
  );
  const toDateToShowRef = useRef(
    moment(moment().endOf("day")).format("YYYY-MM-DD"),
  );

  let finalArraydata = [];
  const [exportData, setExportData] = React.useState([]);
  const [exportDataPdf, setExportDataPdf] = React.useState([]);
  const [clientIdCommunicationData, setClientIdCommunicationData] =
    useState(emptyArray);
  const [clientIdCommunicationDataHeader, setClientIdCommunicationDataHeader] =
    useState([]);

  const [open, setOpen] = useState({
    Boolean: true,
    text: "Individual Report",
  });
  const [data, setData] = useState([]);
  const clientCommunicationFetchedThroughDashboardRef = React.useRef(false);
  const [combinedUserIdsArr, setCombinedUserIdsArr] = useState([]);

  const [preClientListForDropDown, setPreClientListForDropDown] = useState([]);
  const [clientListForDropDown, setClientListForDropDown] = useState([]);
  const [selectClients, setSelectClients] = useState([]);
  const [clientWiseMeetingCountObj, setClientWiseMeetingCountObj] = useState(
    {},
  );
  console.log("clientWiseMeetingCountObj : ", clientWiseMeetingCountObj);
  console.log("clientListForDropDown : ", clientListForDropDown);

  const topViewNavData = {
    title: "Meetings",
    // backPath: "OD Duties",
    backPathRoute: "/dashboard",
  };
  let labelHeader = [
    "Date",
    "Emp Namea",
    "Vendor/Client/Other",
    "Website",
    "Relationship Type",
    "Person Name",
    "Contact Number",
    "Communication Type",
    "Discussion Detail",
    "Remarks",
    "Total Distance",
    "Total Amount",
  ];

  const getUserId = () => {
    let userId1 = [];
    userId?.map((val) => {
      if (val !== undefined) {
        userId1.push(val.hrmsUserId);
      }
      setuserListId(userId1);
    });
  };

  useEffect(() => {
    getUserId();
  }, [teamfiletdataemp]);

  const fetchHederTitle = () => {
    const Templatedata = JSON.parse(localStorage.getItem("Templatedata"));
    const NewClient =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "New Client") {
          return setNewClientTitle(val.displayName);
        }
      });
    const NewClientCount =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Unique Clients") {
          return setUniqueClients(val.displayName);
        }
      });
    const SelectClientOwner =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Select Client Owner") {
          return setSelectOptonCustomer(val.displayName);
        }
      });
    const SelectClientsataus =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Client Status") {
          return setSelectOptonSatatus(val.displayName);
        }
      });
  };

  const multipleUserId = [];

  singleEmployee &&
    singleEmployee.length >= 0 &&
    singleEmployee.map((ele) => {
      multipleUserId.push(ele.userId);
    });

  console.log(multipleUserId);

  const fetchVendorListForDropDown = async () => {
    let data = {
      userId: localData?.id,
      hrmsUserId: localData?.hrmsUserId,
      companyId: localData?.hrmsCompanyId,
    };
    const res = await SummaryAction.getVendorListForDropDown(data);

    if (res !== null) {
      setPreClientListForDropDown(res?.data?.length > 0 ? res?.data : []);
      setClientListForDropDown(res?.data?.length > 0 ? res?.data : []);
    } else {
      setPreClientListForDropDown([]);
      setClientListForDropDown([]);
    }
  };

  const getSummaryData = async () => {
    sessionStorage.removeItem("navigatedOutdoordutiesFilter");
    const Attendance = JSON.parse(localStorage.getItem("countMeetingList"));
    const meetingCount = JSON.parse(
      localStorage.getItem("scheduledMetingList"),
    );

    setLoading(true);
    setFromDate(
      Attendance !== null
        ? moment(Attendance.startTime).format("YYYY-MM-DD")
        : moment(moment(fromDate).startOf("day")).format("YYYY-MM-DD"),
    );

    const payload = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      fromDate:
        Attendance !== null && Attendance.startTime
          ? moment(Attendance.startTime).format("YYYY-MM-DD")
          : moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
      // userId:
      //   singleEmployee && typeof singleEmployee.userId === "number"
      //     ? singleEmployee.userId
      //     : 0,
      ignoreOdWithoutCommunication: true,
      locationTrackingFrequency: JSON.parse(localStorage.getItem("data"))
        .locationTrackingFrequency,
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      // filterUserId:
      //   Attendance !== null && Attendance.UserId
      //     ? Attendance.UserId
      //     : singleEmployee
      //     ? multipleUserId
      //     : null,
      filterUserIdList:
        Attendance !== null && Attendance.UserId
          ? [Attendance.UserId]
          : singleEmployee
            ? multipleUserId
            : null,
      odExpenseAndFareStatus: StatusId ? StatusId.title : null,
      // filterUserIdList: userListId ? userListId : null,
      // filterUserId: "3",
      clientIds: selectClients?.map((item) => item?.id),
    };
    const res = await SummaryAction.FetchSummaryList(payload);
    if (res !== null && res.responseCode === 200) {
      // setFilterCommunicationDetails(
      //   res.data.map((ele) => ele.communicationDetails)
      // );
      // setCommunicationDetails(res.data.map((ele) => ele.communicationDetails));
      const results = new Map();
      // let results =
      //   res.data &&
      //   res.data.dataList &&
      //   res.data.dataList.reduce(function (results, org) {
      //     (results[org.userId] = results[org.userId] || []).push(org);
      //     return results;
      //   }, {});

      res?.data?.dataList?.forEach((item) => {
        // (results[item.userId] = results[item.userId] || []).push(item);
        if (results.get(item.userId)) {
          const preVal = results.get(item.userId);
          preVal.push(item);
          results.set(item.userId, preVal);
        } else {
          results.set(item.userId, [item]);
        }
      });

      // this data is employeewise
      let arr = [];
      // for (const [key, value] of Object.entries(
      //   results !== undefined ? results : []
      // )) {
      //   arr.push(value);
      // }

      for (const [key, value] of Array.from(results)) {
        arr.push(value);
      }
      // const list = res?.data?.clientWiseMeetingCountList;

      let apiHeadersList = Array.isArray(res?.data?.headerList)
        ? res?.data?.headerList
        : [];
      const indexOfDetails = apiHeadersList.findIndex(
        (item) => item?.name === "Details",
      );

      let mutatedFeSideHeaders = feSideHeaders.map((item) => {
        if (item?.name === "Odometer Details") {
          const templateWiseHeaders =
            JSON.parse(localStorage.getItem("Templatedata")) || [];

          const dynamicOdometerHeader =
            templateWiseHeaders.find(
              (head) => head?.actualName === "Odometer Details",
            ) || null;

          return {
            ...item,
            displayName:
              dynamicOdometerHeader?.displayName || item?.displayName,
            isShowOnWeb: localData?.isOdMeterReadingRequiredOnOd || false,
          };
        } else if (item?.name === "Odometer Distance") {
          const templateWiseHeaders =
            JSON.parse(localStorage.getItem("Templatedata")) || [];

          const dynamicOdometerHeader =
            templateWiseHeaders.find(
              (head) => head?.actualName === "Odometer Distance",
            ) || null;

          return {
            ...item,
            displayName:
              dynamicOdometerHeader?.displayName || item?.displayName,
            isShowOnWeb: localData?.isOdMeterReadingRequiredOnOd || false,
          };
        }

        return item;
      });

      let finalHeaders;

      if (indexOfDetails > 0) {
        finalHeaders = [
          ...apiHeadersList.slice(0, indexOfDetails),
          ...mutatedFeSideHeaders,
          ...apiHeadersList.slice(indexOfDetails),
        ];
      } else {
        finalHeaders = [...apiHeadersList, ...mutatedFeSideHeaders];
      }

      // setClientWiseMeetingCountObj(
      //   Array.isArray(list)
      //     ? list.reduce((acc, item) => {
      //         const id = item?.id;
      //         const count = item?.count ?? 0;
      //         if (id != null) acc[id] = count;
      //         return acc;
      //       }, {})
      //     : {}
      // );

      setFilterCommunicationDetails(res.data.dataList);
      setCommunicationDetails(res.data.dataList);
      // setCommunicationDetailsHeader(res.data.headerList);
      setCommunicationDetailsHeader(finalHeaders);
      const FinalHeader =
        res.data &&
        res.data.dynamicHeaderList !== null &&
        res.data.dynamicHeaderList.map((val) => ({
          ...val,
          IsShowWeb: val.isHidden === false ? true : false,
        }));
      setCommunicationDetailsDynamiceHeader(FinalHeader);
      // exportDataList(res.data);
      setData(arr);
    } else {
      setCommunicationDetails([]);
      setFilterCommunicationDetails([]);
      setData([]);
    }
    setLoading(false);
  };

  const getcommunicationdata = async (data) => {
    setLoading(true);
    const payload = {
      communicationId: data,
    };
    const res = await ScheduledAction.filterHrmData(payload);
    if (res !== null && res.responseCode === 200) {
      setClientIdCommunicationData(
        res.data && res.data.length !== 0 ? res.data : emptyArray,
      );
      // setClientIdCommunicationDataHeader(res.data.headerList);
    } else {
      setClientIdCommunicationData(emptyArray);
    }
    setLoading(false);
  };

  console.log(clientIdCommunicationData, "clientIdCommunicationDataa");

  useEffect(() => {
    debugger;
    if (JSON.parse(localStorage.getItem("ScheduledData"))) {
      const schedule = JSON.parse(localStorage.getItem("ScheduledData"));
      const { communicationId } = schedule;
      console.log(schedule, "communicationId");

      setFromDate1(schedule.createdAt);
      setFromDate(
        moment(
          schedule
            ? schedule.createdAt
            : moment(moment().startOf("day")).format("YYYY-MM-DD"),
        ).format("YYYY-MM-DD"),
      );
      setToDate(
        moment(
          schedule
            ? schedule.createdAt
            : moment(moment().endOf("day")).format("YYYY-MM-DD"),
        ).format("YYYY-MM-DD"),
      );
      getcommunicationdata(communicationId);
      showFilteredData();
      localStorage.removeItem("ScheduledData");
    }
    setLoading(false);
  }, [JSON.parse(localStorage.getItem("ScheduledData")), selectedSite]);
  // const getSummaryData = async () => {
  //   setLoading(true);

  //   const payload = {
  //     fromDate: moment(fromDate).format("DD-MM-YYYY"),
  //     toDate: moment(toDate).format("DD-MM-YYYY"),
  //     employeeId:
  //       singleEmployee && typeof singleEmployee.userId === "number"
  //         ? singleEmployee.userId
  //         : 0,
  //   };
  //   const res = await SummaryAction.FetchSummaryList(payload);
  //   if (res !== null && res.responseCode === 200) {
  //     // setFilterCommunicationDetails(
  //     //   res.data.map((ele) => ele.communicationDetails)
  //     // );
  //     // setCommunicationDetails(res.data.map((ele) => ele.communicationDetails));
  //     setFilterCommunicationDetails(res.data);
  //     setCommunicationDetails(res.data);
  //     setData(res.data);
  //   } else {
  //     setCommunicationDetails([]);
  //     setFilterCommunicationDetails([]);
  //     setData([]);
  //   }
  //   setLoading(false);
  // };
  const teamFilterData = () => {
    let userArraydata = [];
    setTeamfiletdataemp(userList);

    const filterTeam = TeamfilterId?.employeeDtoList?.map((user) => {
      const userFilterData = userList?.filter(
        (val) => val.hrmsUserId == user.id,
      );
      if (userFilterData.length > 0) {
        userArraydata.push(userFilterData[0]);
      }
      // else if(teamfiletdataemp.length == 0){
      //   setTeamfiletdataemp()
      // }
      setTeamfiletdataemp(userArraydata);
      setUserId(userArraydata);
    });
  };

  const teamListData = () => {
    let arraydata = [];
    const filterTeam1 = userList?.map((user) => {
      const teamdata =
        teamList && teamList.filter((val) => val.manager.id == user.hrmsUserId);
      if (teamdata && teamdata.length > 0) {
        arraydata.push(teamdata[0]?.manager);
      }
      setTeamListData(arraydata);
    });
  };
  const getmanagerId = (e) => {
    if (e !== null) {
      setTeamFilterId(e);
    } else {
      setTeamFilterId("");
    }
  };
  const fetchconfigurationdetailsheader = () => {
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const siteId = selectedSite ? selectedSite?.id : null;
    ScheduledAction.configurationdetails({hrmsCompanyId, siteId}).then(
      (response) => {
        if (response !== null) {
          const showheader =
            response &&
            response.data &&
            response.data.filter(
              (val) => val && val.configurationName === "IS_MEETING_DURATION",
            );
          // console.log(object)
          setConfigurationName(
            showheader &&
              showheader.length > 0 &&
              showheader !== undefined &&
              showheader[0].configurationName,
          );

          //localStorage.setItem("configurationdetailsheader", response.data)
        }
      },
    );
  };
  // const fetchshowDistancebyC = () => {
  //   ScheduledAction.FetchshowcompanyBaseHeader().then((response) => {
  //     if (response !== null) {
  //       // setShowHeaderbyCompany(response.data);
  //       const hrmsUserIddata = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
  //       const data = response.data.filter((val) => val.hrmsCompanyId == hrmsUserIddata);
  //       console.log( JSON.parse(localStorage.getItem("showHeader"))[0].isActive,"dfbhsdyhfghef")
  //       localStorage.setItem("showHeader", JSON.stringify(data));
  //     } else {
  //       console.log("error");
  //     }
  //   });
  // };

  useEffect(() => {
    teamFilterData();
    teamListData();
  }, [TeamfilterId, userList, selectedSite]);

  // const teamListData = () => {
  //   let arraydata = [];
  //   console.log(arraydata, "arraydatagfdywedytw");
  //   const filterTeam1 = userList.map((user) => {
  //     const teamdata = teamList.filter(
  //       (val) => val.manager.id == user.hrmsUserId
  //     );
  //     console.log(teamdata[0]?.manager, "teamdata");
  //     if (teamdata.length > 0) {
  //       arraydata.push(teamdata[0]?.manager);
  //     }

  //     setTeamListData(arraydata);
  //   });

  //   console.log(teamList, "filterTeam");
  // };

  const fetchUserList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const data = {
      hrmsUserId: hrmsID,
      userId: JSON.parse(localStorage.getItem("data")).id,
      siteId: selectedSite ? selectedSite?.id : null,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      // setUserList([{ userId: 0, name: "ALL", empCode: "all" }, ...res.data]);
      setUserList(res.data);
    } else {
      setUserList([]);
    }
  };

  const fetchTeamListData = async () => {
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const siteId = selectedSite ? selectedSite?.id : null;
    // const data={
    //   hrmsUserId : JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
    //   userId: JSON.parse(localStorage.getItem("data")).id
    // }
    const res = await SummaryAction.fetchTeamList({ hrmsCompanyId, siteId });
    if (res !== null) {
      setTeamList(res.data);
      //setTeamList([{ userId: 0, firstName: "ALL", employeeCode: "all" }, ...res.data]);
    } else {
      setTeamList([]);
    }
  };

  const validateDates = () => {
    if (!fromDate || !toDate) {
      alert("From and To dates are required.");
      return false;
    }
    if (fromDate > toDate) {
      alert("FromDate should not extend ToDate");
      return false;
    }
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const monthsDifference =
      (to.getFullYear() - from.getFullYear()) * 12 +
      to.getMonth() -
      from.getMonth();
    if (monthsDifference > 2) {
      alert(
        "The difference between From and To dates should be 2 months or less.",
      );
      return false;
    }
    return true;
  };

  const showFilteredData = () => {
    if (validateDates()) {
      fromDateToShowRef.current = moment(fromDate).format("YYYY-MM-DD");
      toDateToShowRef.current = moment(toDate).format("YYYY-MM-DD");
      getSummaryData(fromDate, toDate, singleEmployee);
      setClientIdCommunicationData(emptyArray);
    } else {
      setCommunicationDetails([]);
      setFilterCommunicationDetails([]);
      setData([]);
    }
    setClientIdCommunicationData(emptyArray);
    // getSummaryData(fromDate, toDate, singleEmployee);
    // setClientIdCommunicationData([]);
    // if (fromDate > toDate) {
    //   alert("FromDate should not extend ToDate");
    // }
  };

  const switchToOtherPage = (data) => {
    if (data == "summary") {
      setOpen({
        Boolean: true,
        text: "Summary Report",
      });
    }
    if (data == "empWise") {
      setOpen({
        Boolean: false,
        text: "Summary Report",
      });
    }
    // if (open.Boolean == true) {

    // } else {
    //   setOpen({
    //     Boolean: true,
    //     text: "Individual Report",
    //   });
    // }
  };
  const displayEmpWise = useSelector((state) => state.redirectSlice.value);
  useEffect(() => {
    if (!displayEmpWise) {
      setOpen({
        Boolean: displayEmpWise,
        text: "Summary Report",
      });
    }
  }, [displayEmpWise]);

  const fetchGetSummaryReportExportExcel = async () => {
    const Attendance = JSON.parse(localStorage.getItem("countMeetingList"));
    const payload = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      fromDate:
        Attendance !== null && Attendance.startTime
          ? moment(Attendance.startTime).format("YYYY-MM-DD")
          : moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
      // userId:
      //   singleEmployee && typeof singleEmployee.userId === "number"
      //     ? singleEmployee.userId
      //     : 0,
      ignoreOdWithoutCommunication: true,
      locationTrackingFrequency: JSON.parse(localStorage.getItem("data"))
        .locationTrackingFrequency,
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      // filterUserId:
      //   Attendance !== null && Attendance.UserId
      //     ? Attendance.UserId
      //     : singleEmployee
      //     ? multipleUserId
      //     : null,
      filterUserIdList:
        Attendance !== null && Attendance.UserId
          ? [Attendance.UserId]
          : singleEmployee
            ? multipleUserId
            : null,
      odExpenseAndFareStatus: StatusId ? StatusId.title : null,
      // filterUserIdList: userListId ? userListId : null,
      // filterUserId: "3",
    };
    setLoading(true);
    const res = await SummaryAction.getExportSummaryRportExcelBlob(payload);
    if (res !== null) {
      setLoading(false);

      // expenseExportBlob(res, "Meeting List.xlsx");
      const err = expenseExportBlob(res, "Meeting List.xlsx");
      if (err instanceof Error) {
        console.error("Export failed:", err?.message);
        alert(err?.message || "Something Went Wrong!");
      }
    } else {
      setLoading(false);
      console.error("No data to export.");
    }
  };

  const fetchGetEmpWiseReportExportExcel = async (selectedUserId) => {
    const Attendance = JSON.parse(localStorage.getItem("countMeetingList"));
    const payload = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      fromDate:
        Attendance !== null && Attendance.startTime
          ? moment(Attendance.startTime).format("YYYY-MM-DD")
          : moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
      // userId:
      //   singleEmployee && typeof singleEmployee.userId === "number"
      //     ? singleEmployee.userId
      //     : 0,
      ignoreOdWithoutCommunication: true,
      locationTrackingFrequency: JSON.parse(localStorage.getItem("data"))
        .locationTrackingFrequency,
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      // filterUserId:
      //   Attendance !== null && Attendance.UserId
      //     ? Attendance.UserId
      //     : singleEmployee
      //     ? multipleUserId
      //     : null,
      filterUserIdList:
        Attendance !== null && Attendance.UserId
          ? [Attendance.UserId]
          : selectedUserId
            ? [selectedUserId]
            : singleEmployee?.length > 0
              ? multipleUserId
              : combinedUserIdsArr,
      odExpenseAndFareStatus: StatusId ? StatusId.title : null,
      // filterUserIdList: userListId ? userListId : null,
      // filterUserId: "3",
    };
    setLoading(true);
    const res = await SummaryAction.getExportEmpWiseRportExcelBlob(payload);
    if (res !== null) {
      setLoading(false);
      const err = expenseExportBlob(
        res,
        selectedUserId ? "EMP Wise Report.xlsx" : "CombineEmpWiseReport.xlsx",
      );
      if (err instanceof Error) {
        console.error("Export failed:", err?.message);
        alert(err?.message || "Something Went Wrong!");
      }
    } else {
      setLoading(false);
      console.error("No data to export.");
    }
  };

  const exportIndividualReport = ({
    userId = null,
    fromDate = null,
    toDate = null,
  } = {}) => {
    exportEmployeewiseReportExcel({
      headerList: [
        ...(communicationDetailsHeader &&
        communicationDetailsHeader instanceof Array
          ? communicationDetailsHeader
              .filter((staticHeader) =>
                staticHeader.name === "Odometer Details" ||
                staticHeader.name === "Odometer Distance"
                  ? localData?.isOdMeterReadingRequiredOnOd
                  : staticHeader.name !== "Details",
              )
              .map((staticHeader) => ({
                ...staticHeader,
                isStatic: true,
              }))
          : []),
        ...(communicationDetailsDynamiceHeader &&
        communicationDetailsDynamiceHeader instanceof Array
          ? communicationDetailsDynamiceHeader.map((dynamicHeader) => ({
              ...dynamicHeader,
              isStatic: false,
            }))
          : []),
      ],
      dataList: communicationDetails,
      userId,
      fromDate,
      toDate,
    });
  };

  const exportHandler = (type) => {
    const headerListToExport = [
      ...(communicationDetailsHeader &&
      communicationDetailsHeader instanceof Array
        ? communicationDetailsHeader
            .filter((staticHeader) =>
              staticHeader.name === "Odometer Details" ||
              staticHeader.name === "Odometer Distance"
                ? localData?.isOdMeterReadingRequiredOnOd
                : staticHeader.name !== "Details",
            )
            .map((staticHeader) => ({
              ...staticHeader,
              isStatic: true,
            }))
        : []),
      ...(communicationDetailsDynamiceHeader &&
      communicationDetailsDynamiceHeader instanceof Array
        ? communicationDetailsDynamiceHeader.map((dynamicHeader) => ({
            ...dynamicHeader,
            isStatic: false,
          }))
        : []),
    ];
    if (open.Boolean) {
      exportSummaryReportExcel({
        headerList: headerListToExport,
        dataList: communicationDetails,
      });
      // fetchGetSummaryReportExportExcel();
      // setTimeout(() => {
      // document.getElementById("test-table-xls-button").click();
      // setLoading(false);
      // }, 500);
    } else {
      exportEmployeewiseReportExcel({
        headerList: headerListToExport,
        dataList: communicationDetails,
        fromDate:
          fromDateToShowRef.current &&
          moment(fromDateToShowRef.current).format("DD/MM/YYYY"),
        toDate:
          toDateToShowRef.current &&
          moment(toDateToShowRef.current).format("DD/MM/YYYY"),
      });
      // fetchGetEmpWiseReportExportExcel();
      // setTimeout(() => {
      // document.getElementById("exportbutton").click();
      // }, 500);
    }
  };

  //   const empWiseGroupExport = () => {
  // setTimeout(() => {
  //   document.getElementById("emp-wise-group-button").click();
  //   setLoading(false);
  // }, 500);
  //   }

  const exportHandler1 = (type) => {
    // setTimeout(() => {
    //   document.getElementById("imployeWiseTable").click();
    //   setLoading(false);
    // }, 500);
  };

  const showAttendceHandler = () => {
    navigate("/ShowAttendanceView");
  };

  useEffect(() => {
    if (id) {
      const singleCommunicationDetails =
        teamfiletdataemp &&
        teamfiletdataemp.length > 0 &&
        teamfiletdataemp?.filter((ele) => ele.userId === +id);
      setSingleEmployee(singleCommunicationDetails);
    }
  }, [teamfiletdataemp]);
  useEffect(() => {
    if (id) {
      if (singleEmployee.length === 1) {
        if (!clientCommunicationFetchedThroughDashboardRef?.current) {
          getSummaryData();
          clientCommunicationFetchedThroughDashboardRef.current = true;
        }
      }
    }
  }, [singleEmployee, selectedSite]);

  useEffect(() => {
    if (Array.isArray(data) && Boolean(data?.length > 0)) {
      const extractedIds = data?.map((item) => item[0]?.userId);
      setCombinedUserIdsArr(extractedIds);
    } else {
      setCombinedUserIdsArr([]);
    }
  }, [data, selectedSite]);

  useEffect(() => {
    // fetchVendorListForDropDown();
    fetchHederTitle();
    fetchUserList();
    fetchTeamListData();
    if (!sessionStorage?.getItem("navigatedOutdoordutiesFilter")) {
      getSummaryData();
    }
    fetchconfigurationdetailsheader();
    localStorage.removeItem("countMeetingList");
    //fetchshowDistancebyC();
  }, [selectedSite]);

  // useEffect(() => {
  //   if (
  //     !clientWiseMeetingCountObj ||
  //     Object.keys(clientWiseMeetingCountObj).length === 0
  //   )
  //     return;

  //   setClientListForDropDown((prevList) => {
  //     if (!Array.isArray(prevList) || prevList.length === 0) return prevList;

  //     // Only update if counts exist
  //     return prevList.map((item) => ({
  //       ...item,
  //       count: clientWiseMeetingCountObj[item?.id] ?? 0, // attach count safely
  //     }));
  //   });
  // }, [clientWiseMeetingCountObj]);

  // useEffect(() => {
  //   if (
  //     !clientWiseMeetingCountObj ||
  //     Object.keys(clientWiseMeetingCountObj).length === 0 ||
  //     !Array.isArray(preClientListForDropDown) ||
  //     preClientListForDropDown.length === 0
  //   )
  //     return;

  //   const mergedList = preClientListForDropDown.map((item) => ({
  //     ...item,
  //     count: clientWiseMeetingCountObj[item?.id] ?? 0,
  //   }));

  //   setClientListForDropDown(mergedList);
  // }, [clientWiseMeetingCountObj, preClientListForDropDown]);

  return (
    <main className="contents__root">
      <LoadingComponent isLoading={loading} />
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "end",
            justifyContent: "space-between",
          }}
        >
          <TopViewNav
            topViewNavData={topViewNavData}
            isDetails={true}
            ViewEmpCount={true}
            Pending={777}
            TotalEmp={100}
            Approved={90}
            Rejected={80}
            topExcel={true}
          />
          <Grid></Grid>
          <Grid sx={{ display: "flex", alignItems: "end", gap: "10px" }}>
            <div>
              <div
                onClick={showAttendceHandler}
                style={{
                  cursor: "pointer",
                }}
              >
                <Tooltip title="Show Attendance View">
                  <IconButton
                    sx={{
                      background:
                        "linear-gradient(to bottom, #21a9b0, rgb(6, 85, 109))",
                    }}
                  >
                    <AttributionIcon sx={{ color: "#FFF" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <ShoeListHeader
              clientListHeader={communicationDetailsHeader}
              setClientListHeader={setCommunicationDetailsHeader}
              setCommunicationDetailsDynamiceHeader={
                setCommunicationDetailsDynamiceHeader
              }
              dyNamiceHeaderList={communicationDetailsDynamiceHeader}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          className="report_body"
          sx={{
            backgroundColor: "none",
            marginTop: "8px",
          }}
        >
          {/* <div style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="table-to-xls"
              filename="Meeting List"
              sheet="tablexls"
              buttonText="Download as XLS"
            />
          </div> */}
          {/* <div
            style={{
              display: "none",
            }}
          >
            <CombineEmpWiseReport
              // fromDate={fromDate}
              // toDate={toDate}
              fromDate={fromDateToShowRef?.current || ""}
              toDate={toDateToShowRef?.current || ""}
              filterCommunicationDetails={filterCommunicationDetails}
              communicationDetailsHeader={communicationDetailsHeader}
            />
          </div> */}

          {/* <div style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="emp-wise-group-button"
              className="download-table-xls-button"
              table="emp-wise-group"
              filename="Meeting List"
              sheet="tablexls"
              buttonText="Download as XLS"
            />
          </div> */}

          {/* <div style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="imployeWiseTable"
              className="download-table-xls-button"
              table="table-to-xls"
              filename="EMP Wise Report"
              sheet="tablexls"
              buttonText="ImployeWiseTable as XLS"
            />
          </div> */}
          <div style={{ display: "none" }}>
            {/* <ExportReport
              exportData={exportData || []}
              labelHeader={labelHeader || []}
              exportHeading={["VehicleList"]}
            /> */}
            {/* <ExportPdf
              exportData={exportDataPdf || []}
              labelHeader={labelHeader || []}
              title="Vehicle List"
              reportName="VehicleList"
            /> */}
          </div>
          <Paper
            elevation={4}
            className="bgs"
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <>
              <ReportHeader
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                userList={userList || []}
                teamList={teamList || []}
                teamfiletdataemp={teamfiletdataemp}
                setTeamfiletdataemp={setTeamfiletdataemp}
                TeamListData={TeamListData}
                getmanagerId={getmanagerId}
                setTeamListData={setTeamListData}
                setSingleEmployee={setSingleEmployee}
                singleEmployee={singleEmployee}
                TeamfilterId={TeamfilterId}
                setTeamFilterId={setTeamFilterId}
                setuserListId={setuserListId}
                userListId={userListId}
                showFilteredData={showFilteredData}
                switchToOtherPage={switchToOtherPage}
                open={open}
                exportHandler={exportHandler}
                exportHandler1={exportHandler1}
                setClientIdCommunicationData={setClientIdCommunicationData}
                showHeaderbyCompany={showHeaderbyCompany}
                setStatusId={setStatusId}
                selectOptonCustomer={selectOptonCustomer}
                selectOptonSatatus={selectOptonSatatus}
                clientListForDropDown={clientListForDropDown}
                selectClients={selectClients}
                setSelectClients={setSelectClients}
                // empWiseGroupExport={empWiseGroupExport}
              />
              {/* <Divider variant="middle" /> */}
              {/* {open.Boolean ? ( */}
              <div style={{ display: open?.Boolean ? "block" : "none" }}>
                <SummaryReport
                  communicationDetails={communicationDetails}
                  showHeaderbyCompany={showHeaderbyCompany}
                  filterCommunicationDetails={filterCommunicationDetails}
                  clientIdCommunicationData={clientIdCommunicationData}
                  clientIdCommunicationDataHeader={communicationDetailsHeader}
                  communicationDetailsDynamiceHeader={
                    communicationDetailsDynamiceHeader
                  }
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  setCommunicationDetails={setCommunicationDetails}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  companyToken={
                    JSON.parse(localStorage.getItem("data")).companyToken
                  }
                  setTotalEmp={setTotalEmp}
                  configurationName={configurationName && configurationName}
                />
              </div>
              {/* ) : ( */}
              <div style={{ display: open?.Boolean ? "none" : "block" }}>
                <IndividualReport
                  communicationDetails={communicationDetails}
                  communicationDetailsHeader={communicationDetailsHeader}
                  data={data}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  fromDate={fromDateToShowRef?.current || ""}
                  toDate={toDateToShowRef?.current || ""}
                  companyToken={
                    JSON.parse(localStorage.getItem("data")).companyToken
                  }
                  configurationName={configurationName && configurationName}
                  communicationDetailsDynamiceHeader={
                    communicationDetailsDynamiceHeader
                  }
                  NewClientTitle={NewClientTitle}
                  UniqueClients={UniqueClients}
                  fetchGetEmpWiseReportExportExcel={
                    fetchGetEmpWiseReportExportExcel
                  }
                  exportIndividualReport={exportIndividualReport}
                />
              </div>
              {/* )} */}
            </>
          </Paper>
        </Grid>
      </Grid>
      {/* <div style={{ display: "none" }}>
        <SummaryReportExportExcel
          communicationDetails={communicationDetails}
          showHeaderbyCompany={showHeaderbyCompany}
          filterCommunicationDetails={filterCommunicationDetails}
          clientIdCommunicationData={clientIdCommunicationData}
          clientIdCommunicationDataHeader={communicationDetailsHeader}
          communicationDetailsDynamiceHeader={
            communicationDetailsDynamiceHeader
          }
          // setFromDate={setFromDate}
          // setToDate={setToDate}
          setCommunicationDetails={setCommunicationDetails}
          // fromDate={fromDate}
          // toDate={toDate}
          companyToken={JSON.parse(localStorage.getItem("data")).companyToken}
          setTotalEmp={setTotalEmp}
          configurationName={configurationName && configurationName}
        />
      </div> */}
    </main>
  );
};

export default Report;
